import { StateOrderIdentification } from '../../enums/StateOrderIdentification';
import { ProfileType } from '../../enums/ProfileType';
import { SeparationType } from '../../enums/SeparationType';
import { State } from '../../models/State';
import { Session } from '../../models/Session';

export const orderStatesForGlobalPicker = [
  {
    id: 5001, name: 'Pendente Vendedor',
    orderStateList: [StateOrderIdentification.PendenteVendedor],
    prescriptionStateList: [],
    separationTypes: []
  },
  {
    id: 5002, name: 'Aguardando Separação',
    orderStateList: [StateOrderIdentification.AguardandoSeparacao],
    prescriptionStateList: [],
    separationTypes: []
  }
];

export const orderStates = [
  { id: 71, name: 'Pendente Vendedor', finalStep: true, previous: [], next: [7, 90, 91, 9, 10, 11, 12, 13, 17, 18, 19, 20, 21, 22], equivalents: [], profileTranslation: [] },
  { id: 1, name: 'Pendente Registro Omie', finalStep: false, previous: [], next: [7, 90, 9, 10, 11, 12, 13, 17, 18, 19, 20, 21, 22], equivalents: [], profileTranslation: [] },
  { id: 7, name: 'Aguardando Separação', finalStep: false, previous: [1, 71], next: [90, 9, 10, 11, 12, 13, 17, 18, 19, 20, 21, 22], equivalents: [], profileTranslation: [] },
  { id: 90, name: 'Pedido Separado', finalStep: false, previous: [7, 1, 71], next: [91, 9, 10, 11, 12, 13, 17, 18, 19, 20, 21, 22], equivalents: [], profileTranslation: [] },
  { id: 91, name: 'Pedido Recebido Montagem', finalStep: true, previous: [90, 7, 1, 71], next: [12, 13], equivalents: [], profileTranslation: [] },
  { id: 9, name: 'Aguardando Faturamento', finalStep: false, previous: [7], next: [10, 11, 12, 13, 17, 18, 19, 20, 21, 22], equivalents: [], profileTranslation: [] },
  { id: 200, name: 'Pedido Faturando', finalStep: true, previous: [9], next: [201, 10], equivalents: [], profileTranslation: [] },
  { id: 201, name: 'Pedido Faturado', finalStep: true, previous: [9], next: [10], equivalents: [], profileTranslation: [] },
  { id: 10, name: 'NF Impressa', finalStep: false, previous: [9, 7, 1, 71], next: [11, 12, 13, 17, 18, 19, 20, 21, 22], equivalents: [], profileTranslation: [] },
  { id: 11, name: 'Aguardando Packing', finalStep: false, previous: [10, 9, 7, 1], next: [12, 13, 22], equivalents: [], profileTranslation: [] },
  {
    id: 12, name: 'Pronto para Envio', finalStep: false, previous: [11, 10, 9, 90, 7, 1], next: [13, 22], equivalents: [], profileTranslation: [
      { name: 'Pronto para Entrega', profileId: ProfileType.Vendor }
    ]
  },
  {
    id: 13, name: 'Enviado', finalStep: false, previous: [12, 11, 10, 9, 90, 7, 1], next: [], equivalents: [{ profileId: ProfileType.Vendor, stateId: 50 }], profileTranslation: [
      { name: 'Entregue', profileId: ProfileType.Vendor }
    ]
  },
  { id: 17, name: 'Aguardando Cliente', finalStep: false, previous: [9], next: [22], equivalents: [], profileTranslation: [] },
  { id: 18, name: 'Aguardando Armação', finalStep: false, previous: [9], next: [21, 11, 12], equivalents: [], profileTranslation: [] },
  { id: 19, name: 'Aguardando Correção', finalStep: false, previous: [9], next: [22], equivalents: [], profileTranslation: [] },
  { id: 20, name: 'Erro na Separação', finalStep: false, previous: [7], next: [9, 22], equivalents: [], profileTranslation: [] },
  { id: 21, name: 'Problema na Armação', finalStep: false, previous: [7], next: [9, 22], equivalents: [], profileTranslation: [] },
  { id: 22, name: 'Cancelado', finalStep: true, previous: [], next: [], equivalents: [], profileTranslation: [] },
];

export const orderDeliveryStates = [
  { id: 30, name: 'Em Coleta', finalStep: false, previous: [], next: [40, 41, 50, 61, 70], equivalents: [], profileTranslation: [] },
  { id: 40, name: 'Em Transporte', finalStep: false, previous: [], next: [41, 50, 61, 70], equivalents: [], profileTranslation: [] },
  { id: 41, name: 'Em Transporte - Alerta', finalStep: false, previous: [], next: [40, 50, 61, 70], equivalents: [{ profileId: null, stateId: 42 }], profileTranslation: [] },
  { id: 50, name: 'Entregue', finalStep: true, previous: [], next: [], equivalents: [], profileTranslation: [] },
  { id: 61, name: 'Não Entregue - Alerta', finalStep: false, previous: [], next: [70], equivalents: [{ profileId: null, stateId: 62 }], profileTranslation: [] },
  { id: 70, name: 'Não Entregue - OK', finalStep: true, previous: [], next: [], equivalents: [], profileTranslation: [] },
];

export const allOrderStates = [
  ...orderStates,
  ...orderDeliveryStates
];

export class StatesService {

  get = (): State[] => orderStates;
  getDelivery = (): State[] => orderDeliveryStates;

  getTranslateByUserProfile(userProfile?: ProfileType) {
    return this.translateListByUserProfile(this.get(), userProfile);
  }
  getDeliveryTranslateByUserProfile(userProfile?: ProfileType) {
    return this.translateListByUserProfile(this.getDelivery(), userProfile);
  }

  getNext(id?: number) {
    if (!id) return [];
    const next = this.get().find(x => x.id === id)?.next || [];
    if (!next.length) return [];
    const result = next.map(n => {
      return this.get().find(g => g.id === n);
    }).filter(n => !!n) as State[];
    return result;
  };
  getDeliveryNext(id?: number, considerSended?: boolean) {
    if (!id) return [];
    let next = this.getDelivery().find(x => x.id === id)?.next || [];
    if (!next.length) {
      if (id === StateOrderIdentification.Enviado && considerSended) {
        next = this.getDelivery().filter(x => x.finalStep).map(x => x.id);
      } else {
        return [];
      }
    }
    const result = next.map(n => {
      return this.getDelivery().find(g => g.id === n);
    }).filter(n => !!n) as State[];
    return result;
  };

  getPrevious(id?: number) {
    if (!id) return [];
    const previous = this.get().find(x => x.id === id)?.previous || [];
    if (!previous.length) return [];
    const result = previous.map(n => {
      return this.get().find(g => g.id === n);
    }).filter(n => !!n) as State[];
    return result;
  };
  getDeliveryPrevious(id?: number) {
    if (!id) return [];
    const previous = this.getDelivery().find(x => x.id === id)?.previous || [];
    if (!previous.length) return [];
    const result = previous.map(n => {
      return this.getDelivery().find(g => g.id === n);
    }).filter(n => !!n) as State[];
    return result;
  };

  getWithEquivalents(id?: number, userProfile?: ProfileType) {
    if (!id) return [];
    const equivalents = this.get().find(x => x.id === +id)?.equivalents?.filter(e => !e.profileId || e.profileId == userProfile)?.map(e => e.stateId)
      || this.getDelivery().find(x => x.id === +id)?.equivalents?.filter(e => !e.profileId || e.profileId == userProfile)?.map(e => e.stateId)
      || [];

    return [id, ...equivalents];
  }

  stateIdIsDeliverable(id?: number) {
    if (!id) return false;
    id = +id;
    return (
      id === StateOrderIdentification.Enviado ||
      id === StateOrderIdentification.EmColeta ||
      id === StateOrderIdentification.EmTransporte ||
      id === StateOrderIdentification.EmTransporteAlertaInterno ||
      id === StateOrderIdentification.EmTransporteAlertaInternoExterno ||
      id === StateOrderIdentification.Entregue ||
      id === StateOrderIdentification.NaoEntregueAlertaInterno ||
      id === StateOrderIdentification.NaoEntregueAlertaInternoExterno ||
      id === StateOrderIdentification.NaoEntregueOK
    );
  }

  filterByUserProfile(list?: State[], userProfile?: ProfileType) {
    if (!list || list.length === 0) return [];

    const statesProfileToFilter: number[] = [];

    if (userProfile === ProfileType.Vendor) {
      statesProfileToFilter.push(
        StateOrderIdentification.PendenteVendedor,
        StateOrderIdentification.AguardandoSeparacao,
        StateOrderIdentification.PedidoSeparado,
        StateOrderIdentification.PedidoRecebidoMontagem,
        StateOrderIdentification.ProntoParaEnvio,
        StateOrderIdentification.Enviado
      );
    }

    if (userProfile === ProfileType.Ecommerce) {
      list = list.filter(s =>
        s.id !== StateOrderIdentification.PedidoSeparado &&
        s.id !== StateOrderIdentification.PendenteVendedor &&
        s.id !== StateOrderIdentification.PedidoRecebidoMontagem &&
        s.id !== StateOrderIdentification.ErroNaSeparacao &&
        s.id !== StateOrderIdentification.PedidoFaturando
      );
    }

    return statesProfileToFilter.length > 0
      ? list.filter(s => statesProfileToFilter.some(spid => spid === s.id))
      : list;
  }

  translateListByUserProfile(list?: State[], userProfile?: ProfileType) {
    if (!list || list.length === 0) return [];

    return list.map(item => ({ ...item, name: item.profileTranslation.find(pt => pt.profileId === userProfile)?.name || item.name }));
  }

  translateByUserProfile(currentId?: StateOrderIdentification, currentName?: string, userProfile?: ProfileType) {
    if (!currentId || !userProfile) return currentName;
    return allOrderStates
      .find(os => os.id === currentId)?.profileTranslation
      .find(pt => pt.profileId === userProfile)?.name || currentName;
  }

  getByUserProfileAndSeparationType(session?: Session | null, separationType?: SeparationType) {
    if (!session) return null;

    let states = null;

    switch (session?.user?.profileType) {
      case ProfileType.GlobalPicker:
        states = orderStatesForGlobalPicker;
        break;
      default:
        states = null;
    }

    return states?.filter(s =>
      s.separationTypes.length === 0 ||
      !separationType ||
      s.separationTypes.some(st => +st === +separationType)
    );
  }

}